
element_id_storded = 1;

window.addNewPiece = function(id, action_triggered, partial, element_id , number_id ,locals) {
    $.ajax({
        url: "/assynchronous_dom/update_dom_element",
        type: 'GET',
        data: { 
            id: id,
            action_triggered: action_triggered,
            partial: partial,
            locals: locals,
            number_id: element_id_storded,
            element_id: element_id

         } 
    }).done(function() {
        $('#elements-size').text($(id).children('tr').length)
    });
}


window.replaceDomElement = function(element_id, partial, locals) {
    $.ajax({
        url: "/assynchronous_dom/replace_dom_element",
        type: 'GET',
        data: { 
            element_id: element_id,
            partial: partial,
            locals: locals

         } 
    }).done(function() {});
}


window.showModalWithInfo = function(element_id, partial, locals) {
    $.ajax({
        url: "/assynchronous_dom/show_modal_with_info",
        type: 'GET',
        data: { 
            element_id: element_id,
            partial: partial,
            locals: locals

         } 
    }).done(function() {
    });  
}


window.changePondsInfo = function(){
    source_pond_id = $('#source_pond_id').val();
    destiny_pond_id = $('#destiny_pond_id').val();
    $.ajax({
        url: "/breeding/ponds_movements/check_ponds_mix",
        type: 'POST',
        data:{
          source_pond_id: source_pond_id,
          destiny_pond_id: destiny_pond_id
        }
    }).done(function(e) {

    });  
  }